import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import '../attachments-block/attachments-block';
import { Attachment } from '../bulletin-board.types';
import { fontAwesomeComponentStyles } from '../../variables';

const dateOptions: Intl.DateTimeFormatOptions = {
  hour: 'numeric',
  minute: 'numeric',
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  timeZone: 'America/Chicago',
};

export function formatWhenPosted(
  whenPosted: string | null,
  options = dateOptions,
): string | null {
  return whenPosted
    ? new Intl.DateTimeFormat(undefined, options).format(new Date(whenPosted))
    : null;
}

@customElement('gi-post')
export class GeneralInfoPost extends LitElement {
  @property({ type: String })
  text: string | null = null;

  @property({ type: String })
  created: string | null = null;

  @property({ type: Array })
  attachments: Array<Attachment> = [];

  @property({ type: Number })
  postId: number | null = null;

  @property({ type: Boolean })
  currentUserCanDelete = false;

  @property({ type: Boolean })
  last = false;

  static override styles = [
    fontAwesomeComponentStyles,
    css`
      div.post {
        display: grid;
        grid-template-columns: 70% 20% 10%;
      }

      div.post.no-delete {
        grid-template-columns: 75% 25%;
      }

      div.text,
      div.attachments {
        font-weight: 400;
        font-size: 14px;
      }

      div.created {
        align-self: start;
        justify-self: end;

        font-weight: 400;
        font-size: 12px;
      }

      div.delete {
        justify-self: center;
        cursor: pointer;
      }

      attachments-block {
        justify-self: start;
      }
    `,
  ];

  override render() {
    return html`
      <style></style>
      <div class="post ${!this.currentUserCanDelete ? 'no-delete' : null}">
        <div class="text">${this.text}</div>
        <div class="created">${formatWhenPosted(this.created)}</div>
        <div class="delete">
          ${this.currentUserCanDelete
            ? html`<a @click=${() => this.deletePost(this.postId)}>
                <i class="fa-solid fa-trash"></i>
              </a>`
            : ''}
        </div>

        <attachments-block
          .attachments="${this.attachments}"
        ></attachments-block>
      </div>
      ${this.last ? null : html`<hr />`}
    `;
  }

  // Actions
  deletePost(postId: number | null) {
    // Emit an event for the deletion.
    this.dispatchEvent(
      new CustomEvent('delete', {
        bubbles: true,
        composed: true,
        detail: {
          giPostId: postId,
        },
      }),
    );
  }
}
